import { Component, ViewEncapsulation } from "@angular/core"
import { fuseAnimations } from "@fuse/animations";

@Component({
    standalone      : true,
    selector        : '[loading-icon]',
    templateUrl     : './loading.component.html',
    styleUrls       : ['./loading.component.scss'],
    encapsulation   : ViewEncapsulation.None,
    animations      : fuseAnimations
})
export class LoadingIcon
{ }
